// extracted by mini-css-extract-plugin
export default {"avatar":"CommentThreadCompactAvatar-module__avatar--cuwY0","ring":"CommentThreadCompactAvatar-module__ring--LKWvB"};